// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1506":"5987a45b","2761":"5987a45b","3065":"5987a45b","3368":"5987a45b","3919":"5987a45b","4891":"5987a45b","7322":"5987a45b","7762":"5987a45b","8157":"5987a45b"}[chunkId] + ".chunk.css";
};